import { Box, Typography, Link } from '@mui/material';
import FairtreeLogoDark from '../../resources/assets/images/fairtree-logo.png';
import FairtreeLogo from '../../resources/assets/images/fairtree-logo-dark.png';
import { useColorMode } from '../../hooks/colorModeProvider';
import { useEffect } from 'react';

const PoweredBy = ({ width, overrideMode }) => {
  const { mode, setMode } = useColorMode();

  // useEffect(() => {
  //   if (overrideMode) {
  //     setMode(overrideMode);
  //   }
  // }, [mode, overrideMode, setMode]);

  return (
    <Box display={'flex'}>
      <Link href="https://www.fairtree.com" target="_blank">
        <img
          //src={FairtreeLogo}
          src={mode === 'dark' ? (overrideMode ? FairtreeLogo : FairtreeLogoDark) : FairtreeLogo}
          alt="Fairtree Logo"
          style={{ width: width ? width : '180px', height: 'auto' }}
        />
      </Link>
    </Box>
  );
};

export default PoweredBy;
